import { FacebookIconSvgPSP, InstagramIconSvgPSP, LinkedInIconSvgPSP, MailIconSvgPSP, PhoneIconSvgPSP, WavesIconSvgPSP, XIconSvgPSP, YoutubeIconSvgPSP } from '../../svgImages';
import CordeliaWhiteLogo from '../../../../assets/images/cordelia-white-logo.png';
import './style.scss';
import { linksDataFooterPSP, privacyAndPolicyFooterPSP } from './data';
import { useState } from 'react';
import HelperAccordion from './helperAccordion';

const FooterSectionPSP: React.FC = () => { 
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  
    return (
      <div className="footer-section-wrapper-psp">  
        <div className="footer-wave-wrapper">
          <WavesIconSvgPSP />
        </div>
        <div className="footer-body-section-wrapper">
          <div className="footer-body-section-left">
            <div className="footer-body-section-left-logo-wrapper">
              <img src={CordeliaWhiteLogo} alt="Cordelia footer logo" />
              <div>
                <span>Cordelia Cruises</span>
                <span>A City on the Sea</span>
              </div>
            </div>
            <span className="footer-body-section-left-about-cordelia">
              Cordelia Cruises by Waterways Leisure Tourism Pvt Ltd is India’s premium cruise liner. True to its name,
              Cordelia aspires to promote and drive the cruise culture in India through experiences that are stylish,
              luxurious and most importantly, inherently Indian. Cordelia is a cruise liner for Indians catering to the
              way Indians love to holiday.
            </span>
            <div className="footer-body-section-left-social-media-wrapper">
              <a href="https://in.linkedin.com/company/cordeliacruises" target="_blank">
                <LinkedInIconSvgPSP />
              </a>
              <a href="https://www.instagram.com/cordeliacruises/?hl=en" target="_blank">
                <InstagramIconSvgPSP />
              </a>
              <a href="https://x.com/CordeliaCruises" target="_blank">
                <XIconSvgPSP />
              </a>
              <a href="https://www.facebook.com/cordeliacruises" target="_blank">
                <FacebookIconSvgPSP />
              </a>
              <a href="https://www.youtube.com/channel/UCIGZzyqWsbCH1-VNFsXrY9g" target="_blank">
                <YoutubeIconSvgPSP />
              </a>
            </div>
            <div className="footer-body-section-left-contact-wrapper">
              <span>
                <PhoneIconSvgPSP />
                <a href="tel:+912268811111">+912268811111</a>
              </span>
              <span>
                <MailIconSvgPSP />
                <a href="mailto:info@cordeliacruises.com">info@cordeliacruises.com</a>
              </span>
            </div>
          </div>
          <div className="footer-body-section-middle">
            <span>Links</span>
            <div>{linksDataFooterPSP.map((data) => { return <a href={data.link}>{data.name}</a>})}</div>
          </div>
          <div className="footer-body-section-right">
            <span>Privacy & Policy</span>
            <div>{privacyAndPolicyFooterPSP.map((data) => { return <a href={data.link}>{data.name}</a>})}</div>
          </div>
          <HelperAccordion title='Links' isActive={activeIndex === 0} onClick={() => toggleAccordion(0)}>
            {linksDataFooterPSP.map((data) => { return <a href={data.link}>{data.name}</a>})}
          </HelperAccordion>
          <HelperAccordion title='Privacy & Policy' isActive={activeIndex === 1} onClick={() => toggleAccordion(1)}>
            {privacyAndPolicyFooterPSP.map((data) => { return <a href={data.link}>{data.name}</a>})}
          </HelperAccordion>
          <div className='mobile-screen-social-media-wrapper'>
            <span>Follow Us:</span>
            <div className="social-media-icons-wrapper">
              <a href="https://in.linkedin.com/company/cordeliacruises" target="_blank">
                <LinkedInIconSvgPSP />
              </a>
              <a href="https://www.instagram.com/cordeliacruises/?hl=en" target="_blank">
                <InstagramIconSvgPSP />
              </a>
              <a href="https://x.com/CordeliaCruises" target="_blank">
                <XIconSvgPSP />
              </a>
              <a href="https://www.facebook.com/cordeliacruises" target="_blank">
                <FacebookIconSvgPSP />
              </a>
              <a href="https://www.youtube.com/channel/UCIGZzyqWsbCH1-VNFsXrY9g" target="_blank">
                <YoutubeIconSvgPSP />
              </a>
            </div>
          </div>
        </div>
        <p className='copyright-text-footer-psp'>© 2022 Cordelia Cruises All Rights Reserved</p>
      </div>
    );  
}

export default FooterSectionPSP;